'use strict';

import { easeOutExpo } from "../../../_js/common/_util";

export default class WasThisHelpful {
    constructor() {
        const headerHTML = `<div class="page-feedback">
                                <div class="page-feedback__wrap">
                                    <div class="page-feedback__yes-no">
                                        <p>Was this page helpful?</p>
                                        <input id="BtnYes" type="button" class="page-feedback__btn" value="Yes">
                                        <input id="BtnNo" type="button" class="page-feedback__btn" value="No">
                                    </div>
                                </div>
                            </div>`;

        let selectedValue = "Yes";

        $('.was-this-helpful .webform-submission-form').before(headerHTML);

        $('.page-feedback__btn').on('click', function (e) {
            e.preventDefault();

            $('.page-feedback').slideUp(easeOutExpo);
            $('.was-this-helpful .webform-submission-form').slideDown(easeOutExpo);

            selectedValue = this.value == 'Yes' ? true : false;

            $('.form-item-was-this-page-helpful input[type="checkbox"]').prop('checked', selectedValue);
            $('.form-item-was-this-page-helpful').hide();

            window.gtag('event', this.value, {
                'event_category': 'WasThisPageHelpful',
                'event_label': window.location.href
            });
        });
    }
}
